import { CommonAppEnvironment } from './environment.model'
import { UserProfileType } from '@mediacoach/ui'

export const ENV_COMMON_SETTINGS: CommonAppEnvironment = {
  staticsUrlLocal: 'assets/',
  profileTypeBlacklist: [UserProfileType.DesktopUserProfile, UserProfileType.LiveProUserProfile],
  tokenType: 'Bearer',
  debounceTimeConfig: {
    general: 200,
    cursorChanges: 1000
  },
  i18nDefaultLang: 'en-GB',
  iOSFakeOrigin: 'capacitor://mobileweb.mediacoach.es'
}
